module.exports = require("react-dom");


//////////////////
// WEBPACK FOOTER
// external "react-dom"
// module id = 7
// module chunks = 0